import { render, staticRenderFns } from "./HomeContainer.vue?vue&type=template&id=2b9faa24"
import script from "./HomeContainer.vue?vue&type=script&lang=js"
export * from "./HomeContainer.vue?vue&type=script&lang=js"
import style0 from "./HomeContainer.vue?vue&type=style&index=0&id=2b9faa24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports